<template>
  <div id="software-server-header">
    <b-row no-gutters="" class="text-light">
      <b-col>{{ ip }}</b-col>
      <router-link
        class="float-right text-decoration-none"
        :to="'/clients/' + this.id + '/servers'"
        ><i class="external alternate icon text-primary"
      /></router-link>
    </b-row>
    <b-row no-gutters=""
      ><b-col
        ><h4>{{ name }}</h4></b-col
      >
    </b-row>
  </div>
</template>

<script>
/**
 * @description Affiche les informations de base d'un serveur
 * @author Samuel Colassin
 * @vue-prop {String} name - Le nom du serveur
 * @vue-prop {String} ip - L'adresse ip du serveur
 * @vue-data {Number} id - L'id du client connecté
 */
export default {
  name: "SoftwareServerHeader",
  props: {
    name: {
      required: true,
      type: String
    },
    ip: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      id: this.$user.get().client_id
    };
  }
};
</script>

<style scoped lang="scss">
a {
  &:hover {
    opacity: 70%;
  }
}
</style>
